import { useState } from 'react';
import { Box } from '@mui/material';
import ReservasCalendarPage from './ReservasCalendarPage';
import { useAuth } from '../../../context/AuthContext';

export default function AgendaPage() {
  const { user } = useAuth();
  const readonly = user?.roles?.includes('consultor');
  const [showInactiveUsers, setShowInactiveUsers] = useState(false);

  return (
    <Box>
      <ReservasCalendarPage
        canCreate={!readonly}
        canEdit={!readonly}
        showInactiveUsers={showInactiveUsers}
        onShowInactiveUsersChange={setShowInactiveUsers}
      />
    </Box>
  );
}
